module.exports = __webpack_public_path__ + "static/img/setting-active.80613860.png";